module.exports = __webpack_public_path__ + "static/media/Backing@3x.e367e6e1.png";